(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ic-aura-interactions"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.icAuraBound) return;
  window.icAuraBound = true;
  const root = document.body.dataset.icRoot || '/';
  const drawer = () => document.getElementById('IcCartDrawer');
  const mobileHeader = window.matchMedia('(max-width:989px)');
  const syncHeaderLock = () => {
    const open = document.querySelector('.ic-header .ic-search[open]') || (mobileHeader.matches && document.querySelector('.ic-header .ic-mobile-menu[open]'));
    document.body.classList.toggle('ic-header-open', Boolean(open));
    document.body.classList.toggle('ic-locked', Boolean(open || document.querySelector('dialog[open]')));
    document.querySelectorAll('#MainContent,.ic-footer').forEach(element => { element.inert = Boolean(open); });
  };
  mobileHeader.addEventListener('change', syncHeaderLock);
  let opener;
  let cartBusy = false;
  let pendingTasks = 0;
  let cartQueue = Promise.resolve();
  const setDrawerBusy = () => {
    const dialog = drawer();
    if (!dialog) return;
    dialog.setAttribute('aria-busy', String(pendingTasks > 0));
    dialog.querySelectorAll('input,button').forEach(control => {
      if (!control.hasAttribute('data-ic-cart-close')) control.disabled = pendingTasks > 0;
    });
    const status = dialog.querySelector('[data-ic-drawer-status]');
    if (status) status.textContent = pendingTasks > 0 ? 'Updating your bag…' : '';
  };
  const enqueue = task => {
    pendingTasks += 1;
    setDrawerBusy();
    const next = cartQueue.then(task, task).finally(() => {
      pendingTasks -= 1;
      setDrawerBusy();
    });
    cartQueue = next.catch(() => {});
    return next;
  };
  const showDrawer = source => {
    const dialog = drawer();
    if (!dialog || typeof dialog.showModal !== 'function') { location.href = root + 'cart'; return; }
    document.querySelectorAll('.ic-header details[open]').forEach(el => el.open = false);
    if (!dialog.open) { opener = source || document.activeElement; dialog.showModal(); }
    document.body.classList.add('ic-locked');
  };
  const restoreOpener = () => {
    syncHeaderLock();
    if (opener?.isConnected) opener.focus({ preventScroll: true });
  };
  const closeDrawer = () => drawer()?.close();
  const renderCart = html => {
    if (!html) throw new Error('Your bag has been updated. Please open the bag page to review it.');
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const body = doc.querySelector('[data-ic-drawer-body]');
    if (!body) throw new Error('Please open your bag to review the update.');
    drawer().querySelector('[data-ic-drawer-body]').replaceWith(body);
    const count = body.dataset.itemCount;
    document.querySelectorAll('[data-ic-cart-count]').forEach(el => el.textContent = count);
    document.querySelectorAll('[data-ic-cart-open]').forEach(el => el.setAttribute('aria-label', 'Shopping bag, ' + count + ' items'));
    setDrawerBusy();
  };
  const refresh = () => enqueue(async () => {
    const response = await fetch(root + '?section_id=ic-aura-cart-drawer', { headers: { Accept: 'text/html' } });
    if (!response.ok) throw new Error('Unable to load your bag. Please try again.');
    renderCart(await response.text());
  });
  const updateLine = async (control, quantity) => {
    if (cartBusy) return;
    cartBusy = true;
    const id = control.dataset.icLine || control.dataset.icRemove;
    const isRemove = control.hasAttribute('data-ic-remove');
    const error = drawer().querySelector('[data-ic-drawer-error]');
    error.textContent = '';
    try {
      await enqueue(async () => {
        const response = await fetch(root + 'cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id, quantity, sections: ['ic-aura-cart-drawer'], sections_url: root })
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || 'Unable to update the quantity.');
        renderCart(data.sections?.['ic-aura-cart-drawer']);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
      });
    } catch (e) {
      error.textContent = e.message || 'Unable to update your bag. Please try again.';
      if (control.hasAttribute('data-current-quantity')) control.value = control.dataset.currentQuantity;
    } finally {
      cartBusy = false;
      if (drawer()?.open) {
        const selector = isRemove ? '[data-ic-remove]' : '[data-ic-line]';
        const replacement = Array.from(drawer().querySelectorAll(selector)).find(el => (el.dataset.icLine || el.dataset.icRemove) === id);
        const focusTarget = replacement || drawer().querySelector('#IcDrawerTitle');
        if (focusTarget) { if (!replacement) focusTarget.tabIndex = -1; focusTarget.focus({ preventScroll: true }); }
      }
    }
  };
  document.addEventListener('submit', async event => {
    const form = event.target.closest('form[data-ic-add]');
    if (!form || !window.fetch || !drawer()) return;
    event.preventDefault();
    if (form.dataset.busy === 'true') return;
    const button = event.submitter || form.querySelector('[type="submit"]');
    const buyNow = button?.hasAttribute('data-ic-buy-now');
    const error = form.querySelector('[data-ic-error]') || document.getElementById(form.dataset.icErrorId);
    const stickyError = form.closest('[data-ic-pdp]')?.querySelector('[data-ic-sticky-error]');
    if (error) error.textContent = '';
    if (stickyError) stickyError.textContent = '';
    const submitButtons = Array.from(form.elements).filter(control => control.type === 'submit');
    const body = new FormData(form);
    body.set('sections', 'ic-aura-cart-drawer');
    body.set('sections_url', root);
    form.dataset.busy = 'true';
    submitButtons.forEach(control => { control.disabled = true; control.setAttribute('aria-busy', 'true'); });
    try {
      await enqueue(async () => {
        const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || 'Unable to add this item.');
        renderCart(data.sections?.['ic-aura-cart-drawer']);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
        document.dispatchEvent(new CustomEvent('ic:cart-updated', { detail: data }));
      });
      if (buyNow) location.assign(root + 'checkout');
      else showDrawer(button);
    } catch (e) {
      if (error) error.textContent = e.message || 'Unable to update your bag. Please try again.';
      if (stickyError) stickyError.textContent = e.message || 'Unable to update your bag. Please try again.';
    } finally {
      form.dataset.busy = 'false';
      submitButtons.forEach(control => {
        control.disabled = form.querySelector('[data-ic-pdp-variant]')?.selectedOptions[0]?.dataset.available === 'false';
        control.removeAttribute('aria-busy');
      });
    }
  });
  document.addEventListener('click', async event => {
    if (event.target.closest('[data-ic-search-open]')) {
      document.querySelectorAll('.ic-mobile-menu[open]').forEach(menu => menu.open = false);
      const search = document.querySelector('.ic-header .ic-search');
      if (search) { search.open = true; search.querySelector('input[type="search"]')?.focus({ preventScroll: true }); syncHeaderLock(); }
      return;
    }
    const headerClose = event.target.closest('[data-ic-header-close]');
    if (headerClose) {
      const details = headerClose.closest('details');
      details.open = false;
      details.querySelector('summary')?.focus();
      syncHeaderLock();
    }
    const bagLink = event.target.closest('[data-ic-cart-open]');
    if (bagLink) {
      if (!drawer() || typeof drawer().showModal !== 'function') return;
      event.preventDefault();
      drawer().querySelector('[data-ic-drawer-error]').textContent = '';
      showDrawer(bagLink);
      try { await refresh(); } catch (e) { drawer().querySelector('[data-ic-drawer-error]').textContent = e.message; }
    }
    if (event.target.closest('[data-ic-cart-close]')) closeDrawer();
    const remove = event.target.closest('[data-ic-remove]');
    if (remove) updateLine(remove, 0);
    if (event.target === drawer()) {
      const rect = drawer().getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeDrawer();
    }
    document.querySelectorAll('.ic-header-tools>details[open],.ic-mega[open]').forEach(el => {
      if (!el.contains(event.target)) el.open = false;
    });
  });
  document.addEventListener('change', event => {
    const input = event.target;
    if (!input.matches('[data-ic-line]')) return;
    const quantity = Number(input.value);
    if (input.value !== '' && Number.isInteger(quantity) && quantity >= 0) updateLine(input, quantity);
    else {
      input.value = input.dataset.currentQuantity;
      drawer().querySelector('[data-ic-drawer-error]').textContent = 'Enter a whole quantity of zero or more.';
    }
  });
  document.addEventListener('keydown', event => {
    const openHeader = document.querySelector('.ic-header .ic-search[open]') || (mobileHeader.matches && document.querySelector('.ic-header .ic-mobile-menu[open]'));
    if (event.key === 'Tab' && openHeader && !drawer()?.open) {
      const panel = openHeader.querySelector('.ic-search-panel,nav') || openHeader;
      const controls = Array.from(panel.querySelectorAll('summary,a[href],button,input:not([type="hidden"]),select')).filter(el => !el.disabled && el.getClientRects().length);
      const first = controls[0], last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    }
    if (event.key !== 'Escape' || drawer()?.open) return;
    const active = event.target.closest('.ic-header details[open]') || document.querySelector('.ic-header details[open]');
    if (!active) return;
    event.preventDefault();
    active.open = false;
    active.querySelector('summary')?.focus();
  });
  drawer()?.addEventListener('close', restoreOpener);

  let headerObserver;
  let currentHeader;
  const initializeHeader = () => {
    const header = document.getElementById('shopify-section-ic-aura-header');
    if (!header || header === currentHeader) return;
    currentHeader = header;
    headerObserver?.disconnect();
    const measure = () => document.documentElement.style.setProperty('--ic-header-height', header.getBoundingClientRect().height + 'px');
    const paintScroll = () => header.querySelector('.ic-header')?.classList.toggle('is-scrolled', window.scrollY > (header.querySelector('.ic-announcement')?.getBoundingClientRect().height || 0));
    window.addEventListener('scroll', paintScroll, { passive: true });
    paintScroll();
    measure();
    if ('ResizeObserver' in window) { headerObserver = new ResizeObserver(measure); headerObserver.observe(header); }
    header.querySelectorAll('.ic-mega,.ic-search,.ic-mobile-menu').forEach(details => {
      if (details.classList.contains('ic-mega')) {
        let leaveTimer;
        details.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'mouse' || mobileHeader.matches) return;
          clearTimeout(leaveTimer);
          details.open = true;
        });
        details.addEventListener('pointerleave', event => {
          if (event.pointerType !== 'mouse' || mobileHeader.matches) return;
          leaveTimer = setTimeout(() => { if (!details.contains(document.activeElement)) details.open = false; }, 180);
        });
      }
      details.addEventListener('toggle', () => {
        const summary = details.querySelector('summary');
        if (summary.dataset.icOpenLabel) summary.setAttribute('aria-label', details.open ? summary.dataset.icCloseLabel : summary.dataset.icOpenLabel);
        syncHeaderLock();
        if (!details.open) return;
        header.querySelectorAll('.ic-mega[open],.ic-search[open],.ic-mobile-menu[open]').forEach(other => { if (other !== details) other.open = false; });
        if (details.classList.contains('ic-search')) details.querySelector('input[type="search"]')?.focus({ preventScroll: true });
        if (details.classList.contains('ic-mobile-menu')) details.querySelector('nav [data-ic-header-close]')?.focus({ preventScroll: true });
      });
    });
    header.querySelectorAll('nav a').forEach(link => {
      const url = new URL(link.href, location.href);
      if (url.pathname === location.pathname && url.searchParams.get('view') === new URL(location.href).searchParams.get('view')) link.setAttribute('aria-current', 'page');
    });
  };
  initializeHeader();
  syncHeaderLock();
  document.addEventListener('shopify:section:load', initializeHeader);
})();
  } catch(e) { console.error(e); }
})();

})();
